import RegionsIndex from './RegionsIndex';

export default RegionsIndex;
